import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9668 24C5.11867 23.991 -0.0107366 18.7893 1.68765e-05 11.8656C0.0107703 5.41496 5.46815 0 11.9776 0C18.5157 0 24.0161 5.43825 24 11.9194C23.991 18.8233 18.8186 24.0107 11.9668 24ZM3.04683 12.1577C2.916 16.1965 6.19043 21.0542 11.9883 21.0631C17.4869 21.0631 20.9496 16.6122 20.9657 12.172C20.9818 6.99537 17.0478 3.0336 11.9561 3.06406C6.86431 3.09452 3.04683 6.9882 3.04683 12.1577Z"
      fill="#63BB92"
    />
    <path
      d="M11.948 18.2625C9.70589 18.2625 7.78102 16.9455 7.03903 14.9171C6.68058 13.9405 6.99781 13.0285 7.79715 12.7328C8.65922 12.4139 9.45139 12.8027 9.84569 13.7918C10.24 14.7809 10.9676 15.2253 11.9785 15.2468C12.9893 15.2683 13.7241 14.7325 14.1489 13.8133C14.6238 12.783 15.4034 12.3799 16.2565 12.7561C17.0451 13.102 17.2978 13.9728 16.9018 14.9816C16.1024 17.0225 14.2313 18.2768 11.948 18.2625Z"
      fill="#63BB92"
    />
    <path
      d="M10.3576 9.06184C10.3582 9.45 10.2098 9.82359 9.94306 10.1056C9.6763 10.3877 9.3115 10.5566 8.92382 10.5777C8.72337 10.5941 8.5217 10.5687 8.33152 10.5033C8.14135 10.4379 7.96677 10.3338 7.81879 10.1977C7.6708 10.0615 7.55262 9.89618 7.47167 9.71211C7.39072 9.52804 7.34877 9.32921 7.34844 9.12814C7.33641 8.93539 7.36411 8.74224 7.42981 8.56064C7.49552 8.37903 7.59783 8.21286 7.73041 8.07242C7.86299 7.93197 8.02301 7.82025 8.20055 7.74417C8.37809 7.6681 8.56936 7.62929 8.76252 7.63015C9.67836 7.5979 10.3343 8.19458 10.3576 9.06184Z"
      fill="#63BB92"
    />
    <path
      d="M16.3095 9.09684C16.3121 9.29751 16.2733 9.49656 16.1954 9.68153C16.1175 9.8665 16.0023 10.0334 15.857 10.1718C15.7116 10.3103 15.5393 10.4172 15.3507 10.486C15.1621 10.5547 14.9614 10.5839 14.761 10.5715C14.3725 10.5537 14.0047 10.3915 13.7296 10.1167C13.4544 9.84197 13.2918 9.47444 13.2734 9.08608C13.277 8.88529 13.321 8.68727 13.4028 8.50386C13.4846 8.32044 13.6026 8.1554 13.7497 8.01859C13.8967 7.88177 14.0698 7.77599 14.2587 7.70757C14.4475 7.63915 14.6482 7.60949 14.8488 7.62035C15.0435 7.61506 15.2371 7.64976 15.4178 7.7223C15.5985 7.79484 15.7623 7.90368 15.8992 8.04207C16.0362 8.18047 16.1432 8.34549 16.2138 8.52692C16.2844 8.70834 16.3169 8.90232 16.3095 9.09684Z"
      fill="#63BB92"
    />
  </svg>
);
const IconPositive = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconPositive;
